
import { React, useState, useEffect, useContext } from 'react';
import CustomerTable from '../../utils/manageClient/CustomerTable';
import AddUserModal from './AddUserModal';
import MessageModal from '../../utils/MessageModal';
import { useAuth } from 'react-oidc-context';
import LoadingModal from '../../utils/LoadingModal';
import SearchModal from '../../utils/SearchModal';
import DetailModal from './DetailModal';
import { useDispatch, useSelector } from 'react-redux';
import { setStep } from '../../app/stepSlice';
import ConfirmDeleteModal from '../../utils/manageClient/ConfirmDeleteModal';
import { Form, OverlayTrigger, ThemeProvider, Tooltip } from 'react-bootstrap';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import { TextButton, darkTheme } from '../../utils/funtions';

import SearchIcon from '@mui/icons-material/Search';
import HomeLayout from '../../utils/HomeLayout';
import { SnackbarContext } from '../../App';
import { custom } from 'zod';
import NotificationModal from '../../utils/NotificationModal';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import UploadClients from './UploadClients';

export default (props) => {
  console.log(props);

  const auth = useAuth();
  const [
    isLoadingModalShown,
    setIsLoadingModalShown,
  ] = useState(false);
  const [
    deleteModalShow,
    setDeleteModalShow,
  ] = useState(false);
  const [
    deleteID,
    setDeleteID,
  ] = useState(-1);
  const [
    isLoading,
    setIsLoading,
  ] = useState(true);
  const [
    currentABN,
    setCurrentABN,
  ] = useState(0);
  const [
    currentClientDetail,
    serCurrentClientDetail,
  ] = useState(0);
  const [
    customerData,
    setCustomerData,
  ] = useState([]);
  const [
    detailModalShown,
    setDetailModalShown,
  ] = useState(false);
  const role = useSelector(state => state.step.role);
  const dispatch = useDispatch();
  const storeStep = useSelector(state => state.step.value);
  const [
    sKey,
    setSKey,
  ] = useState('');
  const [
    error,
    setError,
  ] = useState({ message: '', description: '' });
  const [
    errorModalShow,
    setErrorModalShow,
  ] = useState(false);
  const [
    displayedCustomers,
    setDisplayedCustomers,
  ] = useState([]);
  const [
    currentAssignmentView,
    setCurrentAssignmentView,
  ] = useState([]);
  const [
    uploadModalShow,
    setUploadModalShow,
  ] = useState(false);
  const [
    addUserModalShow,
    setAddUserdModalShow,
  ] = useState(false);
  const [
    assignmentModalShow,
    setAssignmentModalShow,
  ] = useState(false);
  const [
    searchModalShowed,
    setSearchModalShowed,
  ] = useState(false);
  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);

  const [
    limitMessageModalShow,
    setLimitMessageModalShow,
  ] = useState(false);

  const [
    userData,
    setUserData,
  ] = useState([]);

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    currentPlan,
    setCurrentPlan,
  ] = useState([]);

  const fetchCurrentPlan = () => {
    fetch(`${window.origin}/api/stripe/plan/current`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      setCurrentPlan(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const handleChange = (event) => {
    searchHandler(event.target.value);
  };

  function searchHandler(searchKeyword) {
    setSKey(searchKeyword);
  }

  function openUploadModal() {
    setUploadModalShow(true);
  }

  function closeUploadModal() {
    setUploadModalShow(false);
  }

  function openDetailModal(client) {
    serCurrentClientDetail(client?.id);
    setDetailModalShown(true);
  }

  function openAddUserModal() {
    if (currentPlan.length == 0 && customerData.length >= 5) {
      setLimitMessageModalShow(true);
      return;
    }

    console.log(customerData.length);
    setAddUserdModalShow(true);
  }

  function openUploadClientsModal() {
    // if(currentPlan.length ==0 && customerData.length >=5){
    //     setLimitMessageModalShow(true)
    //     return
    // }

    // console.log(customerData.length)
    setUploadModalShow(true);
  }

  function closeAddUserModal() {
    setAddUserdModalShow(false);
  }

  function checkClientExist(abn) {
    console.log(customerData);

    if (customerData.find(item => item.ABN == abn)) {
      return true;
    } else {
      return false;
    }
  }

  function confirmAddUser(data) {
    if (!customerData.find(item => item.ABN === data.ABN)) {
      setAddUserdModalShow(false);

      addUser(data).then(() => {
        retrieve_data();
      });
    } else {
      setError({ message: 'ABN already exists', description: 'A client with the provided ABN has already been added to the system!' });
      setErrorModalShow(true);
    }
  }

  function confirmAddBulkCLients(clients) {
    setUploadModalShow(false);

    if (storeStep === 'client') {
      dispatch(setStep('completed'));
    }

    addBulkUser(clients).then(() => {
      retrieve_data();
    });
  }

  async function addUser(client) {
    try {
      const response = await fetch(`${window.origin}/api/client`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          clients: [client],
        }),
      });

      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      } else if (!response.ok) {
        throw Error('Unexpected error occured');
      } else {
        setSnackBarMessage('Client added sucessfully');
        setSnackBarShow(true);
      }
    } catch (error) {
      setSnackBarMessage('Unexpected error occured. Please try again later');
      setSnackBarShow(true);
    }
  }

  async function addBulkUser(clients) {
    setIsLoadingModalShown(true);

    let clientListLength = clients.length;

    console.log(clientListLength);

    let count = 0;

    let subClientList;

    let response;

    while (count + 99 < clientListLength - 1) {
      console.log(`from ${count} to ${count + 99}`);
      subClientList = clients.slice(count, count + 99);

      response = await fetch(`${window.origin}/api/client`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          clients: subClientList,
        }),
      });
      if (response.status === 403) {
        setSessionExpired(true);
      }

      count += 100;
    }

    console.log(`from ${count} to ${clientListLength - 1}`);

    subClientList = clients.slice(count, clientListLength - 1);

    response = await fetch(`${window.origin}/api/client`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
      body: JSON.stringify({
        clients: subClientList,
      }),
    });
    if (response.status === 403) {
      setSessionExpired(true);
    }

    setIsLoadingModalShown(false);
  }

  function openAssignmentModal(abn, currentCustomerId) {
    setCurrentABN(abn);
    // serCurrentCustomerId(currentCustomerId)
    setCurrentAssignmentView([...customerData.find(item => item.ABN == abn).taxAgentEmail]);
    setAssignmentModalShow(true);
  }

  function changeABNHandler(value, id) {
    setCustomerData((oldState) => {
      let newData = JSON.parse(JSON.stringify(oldState));
      newData.find(item => item.id == id).ABN = value;
      return newData;
    });
  }

  function changeadminAccountantEmailsHandler(value, id) {
    setCustomerData((oldState) => {
      let newData = JSON.parse(JSON.stringify(oldState));
      newData.find(item => item.id == id).adminAccountantEmails = value;
      return newData;
    });
  }

  function changeClientNameHandler(value, id) {
    setCustomerData((oldState) => {
      let newData = JSON.parse(JSON.stringify(oldState));
      newData.find(item => item.id == id).clientName = value;
      return newData;
    });
  }

  function deleteConfirmHandler(id) {
    setDeleteID(id);
    setDeleteModalShow(true);
  }

  function deleteCustomer() {
    setDeleteModalShow(false);
    setDetailModalShown(false);

    let id = deleteID;
    setCustomerData(oldState => oldState.filter(item => item.id != id));
    fetch(`${window.origin}/api/reporter/client?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        //   throw new Error('Session expired');
      } else {
        return response.json();
      }
    }).catch((error) => {
      snackBarMessage('Failed to deleted client. Please try again later');
      setSnackBarShow(true);
    });
  }

  async function reload() {
    setIsLoading(true);
    await retrieve_data();
    setIsLoading(false);
  }

  async function retrieve_data() {
    try {
      let response = await fetch(`${window.origin}/api/client`, {
        headers: {
          Authorization: `Bearer ${auth.user?.access_token}`,
        },
      });

      if (response.status === 403) {
        setSessionExpired(true);
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      let data = await response.json();

      let paidDataFetched = data.map((item) => {
        let status;
        if (item.status === 'active') {
          status = 'Active';
        } else if (item.status === 'ctlreq') {
          status = 'Pending';
        } else if (item.status === 'processing') {
          status = 'Pending';
        } else {
          status = 'Inactive';
        }
        return {
          id: item.id,
          clientName: item.clientname,
          ABN: item.clientabn,
          financialSWAccount: item.financial_sw_account,
          financialSWType: item.financial_sw,
          users: item.agentemails,
          status: status,
          statusDetail: item.status_detail,
          contactName: item.contact_name,
          contactEmail: item.contact_email,
          autoForwarding: item.auto_forwarding,
        };
      },
      );
      console.log(data);
      setCustomerData(paidDataFetched);
    } catch (e) {
      console.log('Unknown Error');
    }
  }

  useEffect(() => {
    reload();

    fetchCurrentPlan();

    let timer = setInterval(() => {
      retrieve_data();
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  useEffect(() => {
    let newState;

    if (sKey !== '') {
      newState = customerData.filter((customer) => {
        return customer.clientName.toLowerCase().includes(sKey.toLowerCase()) || customer.ABN.toLowerCase().includes(sKey.toLowerCase());
      });
    } else {
      newState = customerData;
    }

    if (displayedCustomers.length != newState.length) {
      setCurrentPage(1);
    }

    setDisplayedCustomers(newState);
  }, [
    sKey,
    customerData,
  ]);

  useEffect(() => {
    if (auth.user?.profile.accountant.ssid) {
      console.log('execute');
      fetch(`${window.origin}/api/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      }).then((data) => {
        setUserData(data.filter(item => item.email !== auth.user?.profile.email));
        console.log(data.filter(item => item.email !== auth.user?.profile.email));
        // setIsLoading(false)
      }).catch((error) => {
        console.error('Failed to fetch workers:', error);
      });
    }
  }, [auth.user?.profile.accountant.ssid]);

  return (
    <>

      <div className="mainContainer" style={{ padding: 0, fontSize: '0.9vw', backgroundColor: 'rgb(254, 254, 255, 0.8)', border: '2px solid rgb(254, 254, 255, 0.3)', margin: '2vw', padding: '1vw', borderRadius: '2vw' }}>
        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: '1vw', alignItems: 'center', padding: '0.5vw 0.5vw', paddingBottom: '1.5vw' }}>
          <div style={{ backgroundColor: 'rgb(254, 254, 255, 0.5)', borderRadius: '0.8vw', padding: '0.5vw', paddingLeft: '1vw', width: '15vw', color: 'rgb(0, 15, 30, 0.7)' }}>
            <ThemeProvider theme={darkTheme}>

              <SearchIcon style={{ fontSize: '1vw' }} />
            </ThemeProvider>

            <Form.Control
              id="client-search-bar"
              style={{
                display: 'inline', backgroundColor: 'rgba(255,255,255,0)', padding: 0, paddingLeft: '0.5vw',
                border: '1px solid rgb(254, 254, 255, 0)', borderRadius: '6px', fontSize: '0.9vw', maxWidth: '80%', marginLeft: '0', fontWeight: '200',
              }}
              className="shadow-none"
              type="text"
              placeholder="Search"
              // value={searchTerm}
              onChange={handleChange}
            />
          </div>
          <div style={{ flex: 1, textAlign: 'right', paddingLeft: '1vw', paddingRight: '0' }}>
            { currentPlan.length > 0 && auth.user?.profile.groups.includes('client-admin') && (
              <OverlayTrigger
                key="top-submit"
                placement="top"
                overlay={(
                  <Tooltip id="tooltip-submit">
                    Upload Bulk Clients
                  </Tooltip>
                )}
              >
                <TextButton id="create-new-workpaper" variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', marginLeft: '1vw' }} onClick={openUploadClientsModal}>
                  <FileUploadIcon style={{ fontSize: '0.9vw', width: '0.95vw', height: '0.95vw' }} />
                </TextButton>

              </OverlayTrigger>
            )}
            {auth.user?.profile.groups.includes('client-admin') && (
              <OverlayTrigger
                key="top-submit"
                placement="top"
                overlay={(
                  <Tooltip id="tooltip-submit">
                    Add New Client
                  </Tooltip>
                )}
              >
                <TextButton id="create-new-workpaper" variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.5)', marginLeft: '1vw' }} onClick={openAddUserModal}>
                  <i className="fa-solid fa-plus" style={{ fontSize: '0.9vw', width: '0.95vw', height: '0.95vw' }}></i>
                </TextButton>

              </OverlayTrigger>
            )}
          </div>

        </div>

        <div style={{ padding: '0.5vw', paddingTop: '0' }}>
          <div style={{}}>
            <CustomerTable
              onChangedABN={changeABNHandler}
              onChangedClientName={changeClientNameHandler}
              onChangedadminAccountantEmails={changeadminAccountantEmailsHandler}
              customerData={displayedCustomers}
              openAssignmentModal={openAssignmentModal}
              openDetailModalHandler={openDetailModal}
              setCurrentClientDetailHandler={serCurrentClientDetail}
              currentPage={currentPage}
              previousPageHandler={() => { setCurrentPage(oldState => oldState - 1); }}
              nextPageHandler={() => { setCurrentPage(oldState => oldState + 1); }}
              isLoading={isLoading}
            />
          </div>
        </div>

        <AddUserModal users={userData} addUserModalShow={addUserModalShow} closeAddUserModal={closeAddUserModal} confirmAddUser={confirmAddUser} checkClientExist={checkClientExist} />

        <UploadClients users={userData} addUserModalShow={uploadModalShow} closeAddUserModal={() => setUploadModalShow(false)} />

        <MessageModal show={errorModalShow} onClose={() => { setErrorModalShow(false); }} message={error.message} description={error.description} />

        <SearchModal show={searchModalShowed} onHide={() => { setSearchModalShowed(false); }} onSearch={searchHandler} />

        <DetailModal userData={userData} serCurrentClientDetail={serCurrentClientDetail} show={detailModalShown} onClose={() => { setDetailModalShown(false); }} clientId={currentClientDetail} onDeleteConfirm={deleteConfirmHandler} onRefresh={retrieve_data} customerData={displayedCustomers} />

        <ConfirmDeleteModal show={deleteModalShow} onClose={() => { setDeleteModalShow(false); }} onDelete={deleteCustomer} />

        <LoadingModal show={isLoadingModalShown} />

      </div>

      <MessageModal show={limitMessageModalShow} onClose={() => setLimitMessageModalShow(false)} message="Upgrade Required" description="You have reached the maximum number of clients for this plan. Please upgrade to add more client" />

    </>
  );
};
